// Desktop summary rail for the full-screen builders (KAN-763). Pure layout:
// identity first, then cards (both inside `RailFrame`'s ONE scroll region),
// then the submit block as the frame's non-scrolling footer, LAST in the DOM
// (RD-UI-RAILPIN-001). The footer is outside the scroller, so the primary never
// moves while the rail scrolls. It holds the ONLY total and the ONLY primary
// button on the screen.
import { foundation } from '../../../ui';
import { layoutStyles as L } from '../../../pages/logJobLayoutStyles';
import RailFrame from './RailFrame';

const fs = foundation.fontSize;

// RD-UI-RAILPIN-001: the rail is a frame (`RailFrame`) with ONE scroll region
// and the submit block as its footer OUTSIDE the scroller; the block owns the
// designed padding under the primary (it replaces KAN-797's sticky-padding
// trick). Shared with DocumentPreviewRail.
/** The submit block: a plain footer after the scroll region. */
export const submitBlockStyle = L.railSubmitBlock;
const fw = foundation.fontWeight;

const cardTitle = {
  fontSize: fs.sm,
  fontWeight: fw.semibold,
  color: foundation.color.neutral.textMuted,
  margin: 0,
  padding: `${foundation.spacePx[2]} 0`,
};

/** A rail card with an optional small caps title. */
export function RailCard({ title, children, testId }) {
  return (
    <section style={L.railCard} data-testid={testId}>
      {title ? <h3 style={cardTitle}>{title}</h3> : null}
      {children}
    </section>
  );
}

/**
 * @param {object} props
 * @param {import('react').ReactNode} [props.identity]
 * @param {import('react').ReactNode} [props.children] - rail cards.
 * @param {import('react').ReactNode} [props.submit] - total + primary block; rendered LAST.
 * @param {string} [props.testId]
 */
export default function FullScreenSummaryRail({ identity, children, submit, testId = 'fullscreen-flow-rail' }) {
  return (
    <RailFrame
      testId={testId}
      footer={submit ? <div style={submitBlockStyle} data-testid={`${testId}-submit`}>{submit}</div> : null}
    >
      {identity}
      {children}
    </RailFrame>
  );
}
